import React from 'react';
import Sidebar from './Sidebar';
import './Dashboard.css';
import useBlockCheck from '../../hooks/useBlockCheck'; // Import the hook
import InstaDashTopbar from '../../pages/InstaDashTopbar/InstaDashTopbar';

const Dashboard = () => {
  useBlockCheck('instructor'); // 🔥 Prevents blocked instructors from accessing this page


  return (
    <div>
      <InstaDashTopbar />
 
      <div className="main-content">

        {/* Sidebar */}
 
        {/* Main Content */}
        <div className="dashboard-container">

          <Sidebar />

          <div className="dashboard-content">
            <h1 className='head'>Turn Your Skills into Income</h1>
            <p className='headp'>Here you can manage your courses, view Performance, and more.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;